import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccessibilityIcon, BellIcon, FileTextIcon, GlobeIcon, LifeBuoyIcon, LinkIcon, LogOutIcon, RulerIcon, ShieldCheckIcon, ShieldIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Icon } from '../../components/icons/Icon';
import { SettingsGroup, SettingsRow } from '../../components/SettingsList';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { SectionTitle } from '../../components/ui/Card';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
import { useMetrics } from '../../contexts/MetricsContext';
export function Settings() {
  const {
    t,
    locale
  } = useLocale();
  const navigate = useNavigate();
  const {
    unitSystem
  } = useMetrics();
  const {
    signOut
  } = useSession();
  const [logout, setLogout] = useState(false);
  return <div className="px-2 pb-2" data-id="element-3920" data-mp="2ogb8lnb1zjtt">
      <PageHeader title={t('settings.title')} showBack data-id="element-3921" data-mp="2ogksct5i8ur2" />

      <SectionTitle data-id="element-3922" data-mp="2job0v8oqrmmo">{t('settings.group.account')}</SectionTitle>
      <SettingsGroup data-id="element-3923" data-mp="2epgbfnw9qztl">
        <SettingsRow label={t('settings.account')} icon={<Icon name="profile" size={18} data-id="element-3925" data-mp="2en3u9cyc4thl" />} onClick={() => navigate('/config/conta')} data-id="element-3924" data-mp="2eoyip18tf3qf" />
        <SettingsRow label={t('settings.language')} value={locale === 'pt-BR' ? 'Português (BR)' : 'English'} icon={<Icon name="language" size={18} data-id="element-3927" data-mp="32esq33ad803a" />} onClick={() => navigate('/config/idioma')} data-id="element-3926" data-mp="37e5evtksrh8i" />
        <SettingsRow label={t('settings.units')} value={t(`metrics.units.${unitSystem}`)} icon={<Icon name="units" size={18} data-id="element-3929" data-mp="2tdum2kzxfskp" />} onClick={() => navigate('/config/unidades')} data-id="element-3928" data-mp="2ycecoypgtsje" />
      </SettingsGroup>

      <div className="mt-3" data-id="element-3930" data-mp="1mvxs6qz20lpo">
        <SectionTitle data-id="element-3931" data-mp="1hyo3xeneig3f">{t('settings.group.experience')}</SectionTitle>
        <SettingsGroup data-id="element-3932" data-mp="1i1k1h1vc72rc">
          <SettingsRow label={t('settings.notifications')} icon={<Icon name="notification" size={18} data-id="element-3934" data-mp="1offvt1z2nqud" />} onClick={() => navigate('/config/notificacoes')} data-id="element-3933" data-mp="1jfuwurjwjihn" />
          <SettingsRow label={t('settings.accessibility')} icon={<Icon name="accessibility" size={18} data-id="element-3936" data-mp="1eh9vgoswysrm" />} onClick={() => navigate('/config/acessibilidade')} data-id="element-3935" data-mp="1ag7v24n9gao2" />
          <SettingsRow label={t('settings.services')} icon={<Icon name="connection" size={18} data-id="element-3938" data-mp="15glhtv7fmuf9" />} onClick={() => navigate('/config/servicos')} data-id="element-3937" data-mp="10plk4nqho8bp" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3939" data-mp="qt0blsf9gf34">
        <SectionTitle data-id="element-3940" data-mp="qpmdwxhjku20">{t('settings.group.privacy')}</SectionTitle>
        <SettingsGroup data-id="element-3941" data-mp="vrk3sakg6n3x">
          <SettingsRow label={t('settings.privacy')} icon={<Icon name="privacy" size={18} data-id="element-3943" data-mp="hsbxyyts4gqr" />} onClick={() => navigate('/config/privacidade')} data-id="element-3942" data-mp="voph0cdyoq7c" />
          <SettingsRow label={t('settings.security')} icon={<Icon name="security" size={18} data-id="element-3945" data-mp="35d9ncq7y2g9" />} onClick={() => navigate('/config/seguranca')} data-id="element-3944" data-mp="mparbf5mcjnw" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3946" data-mp="3ucy3pjn85l7d">
        <SectionTitle data-id="element-3947" data-mp="c5i8uzl9dujc">{t('settings.group.support')}</SectionTitle>
        <SettingsGroup data-id="element-3948" data-mp="c2no16yc27pe">
          <SettingsRow label={t('settings.help')} icon={<Icon name="help" size={18} data-id="element-3950" data-mp="85rl74r13uj1" />} onClick={() => navigate('/config/ajuda')} data-id="element-3949" data-mp="82vmvfb9r3u2" />
          <SettingsRow label={t('settings.terms')} icon={<FileTextIcon size={17} data-id="element-3952" data-mp="h3tgr4rztuyx" />} onClick={() => navigate('/config/ajuda')} data-id="element-3951" data-mp="h437wvory867" />
          <SettingsRow label={t('settings.policy')} icon={<FileTextIcon size={17} data-id="element-3954" data-mp="quxy2b555rwx" />} onClick={() => navigate('/config/privacidade')} data-id="element-3953" data-mp="vs6cq1r2zdtf" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3955" data-mp="14rbb982n775l">
        <SettingsGroup data-id="element-3956" data-mp="zv30e6vha048">
          <SettingsRow label={t('settings.logout')} icon={<LogOutIcon size={17} data-id="element-3958" data-mp="2ubb9qsie7x16" />} onClick={() => setLogout(true)} data-id="element-3957" data-mp="zvw04nw0rpcv" />
          <SettingsRow label={t('settings.delete')} hint={t('settings.deleteHint')} icon={<Trash2Icon size={17} data-id="element-3960" data-mp="340clg6hwns9c" />} tone="danger" onClick={() => navigate('/config/excluir')} data-id="element-3959" data-mp="2z9mj724s05iv" />
        </SettingsGroup>
      </div>

      <Modal open={logout} onClose={() => setLogout(false)} labelledBy="logout-title" data-id="element-3961" data-mp="3840yh4pb3g1z">
        <div className="px-1 pb-1 pt-3" data-id="element-3962" data-mp="2gaqs3zo7s799">
          <h2 id="logout-title" className="text-title text-deep" data-id="element-3963" data-mp="2gbjygzj9guqv">
            {t('settings.logout.title')}
          </h2>
          <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-3964" data-mp="2keq4c62gojwt">
            {t('settings.logout.body')}
          </p>
          <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={() => {
          signOut();
          navigate('/splash', {
            replace: true
          });
        }} data-id="element-3965" data-mp="3vs0wmpoy68ql">
            {t('settings.logout.confirm')}
          </Button>
          <Button variant="outline" size="lg" fullWidth className="mt-2" onClick={() => setLogout(false)} data-id="element-3966" data-mp="9ptb1l1yxos5">
            {t('common.cancel')}
          </Button>
        </div>
      </Modal>
    </div>;
}